/* eslint-disable prettier/prettier */
export const unCapitalize = (text: string) => {
  let result = '';
  let isFirstLetter = true;

  for (let i = 0; i < text.length; ++i) {
    if (i === 0 || text[i - 1] === '-' || text[i - 1] === ' ') {
      result = result.concat(text[i].toUpperCase());
    } else if (text[i] === "'" && i > 0 && text[i - 1] !== ' ') {
      if (isFirstLetter) {
        // Garder la première lettre avant l'apostrophe en majuscule
        result = result.slice(0, -1) + text[i - 1].toUpperCase() + text[i] + text[i + 1].toUpperCase();
      } else {
        // Mettre la lettre avant l'apostrophe en minuscule
        result = result.slice(0, -1) + text[i - 1].toLowerCase() + text[i] + text[i + 1].toUpperCase();
      }
      i++;
    } else {
      result = result.concat(text[i].toLowerCase());
    }

    if (i > 0) {
      isFirstLetter = false;
    }
  }

  return result;
};